import React, { useEffect } from "react";
import {
  Button,
  Form,
  Table,
  Select,
  DatePicker,
  Space,
  Modal
} from "antd";
import { SearchOutlined, FileSearchOutlined, Loading3QuartersOutlined } from "@ant-design/icons";

import DataInput from './DataInput'

//mobx
import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import { runInAction, set, toJS } from "mobx";
//mobx'

//中文
import 'dayjs/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';

const Data = () => {
  //mobx
  const { DataStore } = useStore();
  const { RangePicker } = DatePicker
  //获得table数据
  useEffect(() => {
    DataStore.getDataList();
    DataStore.getSelectList()
    DataStore.getSelectList2()
    DataStore.getSelectList3()
    // eslint-disable-next-line
  }, []);

  //分页控制
  const onPageChange = (page, pageSize) => {
    runInAction(() => {
      set(DataStore, { page: page, pagesize: pageSize })
    })
    DataStore.getDataList()
  }
  //分页控制

  //新增账户
  const getAddButton = (addTitle, data) => {
    if (addTitle === '编辑' || addTitle === '查看') {
      runInAction(() => {
        set(DataStore, { valueData: toJS(data) });
      })
    }
    runInAction(() => {
      set(DataStore, { title: addTitle, isActive: true });
    });
  };

  // 取消按钮
  const [form] = Form.useForm();
  //表单重置
  const onReset = async () => {
    runInAction(() => {
      set(DataStore, { qyxxid: '', dyglid: '', sbxxid: '', createtime: '', page: 1 })
    })
    await DataStore.getDataList();
    form.resetFields();
  };

  //关闭X按钮
  const handleRevise = () => {
    runInAction(() => {
      set(DataStore, { isActive: false });
    });
  };

  //表单提交
  const onFinish = async (values) => {
    if (values.createtime) {
      values.createtime = [values.createtime[0].format('YYYY-MM-DD'), values.createtime[1].format('YYYY-MM-DD')].join("/")
    }
    runInAction(() => {
      set(DataStore, { qyxxid: values.qyxxid || '', dyglid: values.dyglid || '', sbxxid: values.sbxxid || '', createtime: values.createtime || '', page: 1 })
    })
    await DataStore.getDataList();
  };


  //table 列表
  const columns = [
    {
      title: "ID",
      dataIndex: "aid",
    },
    {
      title: "所属系统",
      dataIndex: "xtmc",
    },
    {
      title: "所属企业",
      dataIndex: "qymc",
    },
    {
      title: "所属单元",
      dataIndex: "dymc",
    },
    {
      title: "所属设备",
      dataIndex: "sbmc",
    },
    {
      title: "更新时间",
      dataIndex: "time",
    },
    {
      title: "空气温度",
      dataIndex: "temperature",
    },
    {
      title: "空气湿度",
      dataIndex: "humidity",
    },
    {
      title: "土壤温度",
      dataIndex: "soil_temperature",
    },
    {
      title: "土壤湿度",
      dataIndex: "soil_moisture",
    },


    {
      title: "操作",
      render: (item) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<FileSearchOutlined />}
            style={{ background: '#40ad63' }}
            onClick={() => getAddButton("查看", item)}
          >查看</Button>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="searchBox">
        <Form
          layout="inline"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item label="所属企业" name='qyxxid'>
            <Select placeholder="请选择" options={toJS(DataStore.selectList2)} style={{ width: '150px' }}>
            </Select>
          </Form.Item>
          <Form.Item label="所属单元" name="dyglid" >
            <Select placeholder="请选择" options={toJS(DataStore.selectList3)} style={{ width: '150px' }}>
            </Select>
          </Form.Item>
          <Form.Item label="所属设备" name='sbxxid'>
            <Select placeholder="请选择" options={toJS(DataStore.selectList)} style={{ width: '150px' }}>
            </Select>
          </Form.Item>
          <Form.Item label='日期范围' name='createtime'>
            <RangePicker locale={locale} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SearchOutlined />} style={{ background: '#40ad63' }}>
              查询
            </Button>
            <Button type="primary" htmlType="button" icon={<Loading3QuartersOutlined />} onClick={onReset} style={{ marginLeft: '15px' }}>
              重置
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="TableInput">
        <div className="buttonBox"></div>
        <div className="total">共有数据:{DataStore.total}条</div>
      </div>

      <div className="contextNr">
        <Table rowKey={(record) => record.id} columns={columns} dataSource={DataStore.dataList} className="table-box"
          pagination={{
            position: ["bottomCenter"],
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ['10', '20', '30'],
            pageSize: DataStore.pagesize,
            current: DataStore.page,
            total: DataStore.total,
            onChange: (page, pageSize) => onPageChange(page, pageSize),
          }}
        />
      </div>
      <Modal
        title={DataStore.title}
        key={new Date()}
        width="1000px"
        open={DataStore.isActive}
        footer={null}
        onCancel={handleRevise}
      >
        <DataInput title={DataStore.title} />
      </Modal>
    </>
  );
};

export default observer(Data);
